export default "__VITE_ASSET__BiiJ5hWy__"